<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Configuration</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Business Information</a></li>
                    </ul>

                    <h3>Manage Business Information</h3>

                    <div class="field">
                        <label for="type">Type</label>
                        <Dropdown v-model="company.type" :options="companyTypes" optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                    </div>

                    <div class="field">
                        <label for="Name">Company Name</label>
                        <InputText id="name" v-model.trim="company.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="tradingName">Trading Name</label>
                        <InputText id="tradingName" v-model.trim="company.tradingName" required="true"/>
                    </div>

                    <div class="field">
                        <label for="registrationNumber">Registration Number</label>
                        <InputText id="registrationNumber" v-model.trim="company.registrationNumber"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressCountry">Country</label>
                        <Dropdown v-model="company.addressCountry" :options="regionTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="address1">Address Line 1</label>
                        <InputText id="address1" v-model.trim="company.address1"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="address2">Address Line 2</label>
                        <InputText id="address2" v-model.trim="company.address2"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressRegion">Region</label>
                        <InputText id="addressRegion"
                                   v-model.trim="company.addressRegion"
                                   required="true"/>
                    </div>

                    <div v-show="company.addressCountry==='ZA'" class="field">
                        <label for="addressState">Province</label>
                        <Dropdown v-model="company.addressState" :options="regionsSouthAfrica"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="company.addressCountry==='UK'" class="field">
                        <label for="addressState">County</label>
                        <InputText id="addressState" v-model.trim="company.addressState"
                                   required="true"/>
                    </div>

                    <div v-show="company.addressCountry!='ZA' && company.addressCountry!='UK'"
                         class="field">
                        <label for="addressState">State</label>
                        <InputText id="addressState" v-model.trim="company.addressState"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Postal Code</label>
                        <InputText id="addressPostalCode"
                                   v-model.trim="company.addressPostalCode"
                                   required="true"/>
                    </div>

                    <div class="field">
                        <label for="email">Email</label>
                        <InputText id="email" v-model.trim="company.email" required="true"/>
                    </div>

                    <div class="field">
                        <label for="phone">Phone</label>
                        <InputText id="phone" v-model.trim="company.phone" required="true"/>
                    </div>

                    <div class="field">
                        <label for="taxRegistered">Tax Registered?</label>
                        <Dropdown v-model="company.taxRegistered" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="company.taxRegistered === 'Y'" class="field">
                        <label for="taxNumber">Tax Number</label>
                        <InputText id="taxNumber" v-model.trim="company.taxNumber" required="true"/>
                    </div>

                    <div v-show="company.taxRegistered === 'Y'" class="field">
                        <label for="taxRate">Tax Rate</label>
                        <InputText id="taxRate" v-model.trim="company.taxRate" required="true"/>
                    </div>

                    <div class="field">
                        <label for="supportEmail">Support Email</label>
                        <InputText id="supportEmail" v-model.trim="company.supportEmail" required="true"/>
                    </div>

                    <div class="field">
                        <label for="supportPhone">Support Phone</label>
                        <InputText id="supportPhone" v-model.trim="company.supportPhone" required="true"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Logo</h3>

                    <div class="field">
                        <label for="logo">Logo</label>
                        <Editor v-model="company.logo" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                    <button class="ql-image"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateCompany"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            company: {},
            bankAccounts: null,
            bankAccount: {},
            newBankAccount: {},
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            bankNamesSouthAfrica: [
                {name: 'ABSA', code: 'ABSA'},
                {name: 'Capitec', code: 'Capitec'},
                {name: 'First National Bank', code: 'First National Bank'},
                {name: 'Investec', code: 'Investec'},
                {name: 'Nedbank', code: 'Nedbank'},
                {name: 'Standard Bank', code: 'Standard Bank'},
                {name: 'Mercentile Bank', code: 'Mercentile Bank'},
                {name: 'Discovery Bank', code: 'Discovery Bank'}
            ],
            accountTypes: [
                {name: 'Current', code: 'C'},
                {name: 'Savings', code: 'S'},
                {name: 'Investment', code: 'I'},
            ],
            companyTypes: [
                {name: 'Sole Proprietor', code: 'S'},
                {name: 'Private Company', code: 'P'},
                {name: 'Non-Profit Company', code: 'N'},
                {name: 'Limited Company', code: 'L'},
                {name: 'Incorporation', code: 'I'},
                {name: 'Co-Operative', code: 'C'}
            ],
            regionsSouthAfrica: [
                {name: 'Gauteng', code: 'Gauteng'},
                {name: 'Western Cape', code: 'Western Cape'},
                {name: 'Kwa-Zulu Natal', code: 'Kwa-Zulu Natal'},
                {name: 'North-West', code: 'North-West'},
                {name: 'Free State', code: 'Free State'},
                {name: 'Eastern Cape', code: 'Eastern Cape'},
                {name: 'Mpumalanga', code: 'Mpumalanga'},
                {name: 'Northern Cape', code: 'Northern Cape'},
                {name: 'Limpopo', code: 'Limpopo'}
            ],
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'India', code: 'IN'},
                {name: 'United States', code: 'US'},
                {name: 'Namibia', code: 'NA'},
                {name: 'Botswana', code: 'BW'},
                {name: 'Australia', code: 'AU'},
                {name: 'New Zealand', code: 'NZ'},
                {name: 'Brazil', code: 'BR'},
                {name: 'China', code: 'CN'},
                {name: 'Egypt', code: 'EG'},
                {name: 'France', code: 'FR'},
                {name: 'Germany', code: 'DE'},
                {name: 'Japan', code: 'JP'},
                {name: 'Spain', code: 'ES'},
                {name: 'Slovenia', code: 'SV'},
                {name: 'Other', code: 'OT'}
            ]
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;
                console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
            }

            try {
                const [companyData, companyConfigData] = await Promise.all([
                    CompanyService.getCompany(this.profile.companyId),
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.company = companyData.data;
                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyData.data = ", companyData.data);
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

            console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[PhoneCalls][mounted] this.company = ", this.company);
            console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);
        },
        async updateCompany() {

            if (this.company.id) {

                var companyDto = {
                    name: this.company.name,
                    tradingName: this.company.tradingName,
                    registrationNumber: this.company.registrationNumber,
                    type: this.company.type,
                    address1: this.company.address1,
                    address2: this.company.address2,
                    addressRegion: this.company.addressRegion,
                    addressState: this.company.addressState,
                    addressCountry: this.company.addressCountry,
                    addressPostalCode: this.company.addressPostalCode,
                    email: this.company.email,
                    phone: this.company.phone,
                    taxRegistered: this.company.taxRegistered,
                    taxNumber: this.company.taxNumber,
                    taxRate: this.company.taxRate,
                    supportEmail: this.company.supportEmail,
                    supportPhone: this.company.supportPhone,
                    logo: this.company.logo
                };

                try {
                    // Delete the appointment
                    const response = await CompanyService.updateCompany(this.company.id, companyDto);
                    console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                    const [companyData] = await Promise.all([
                        CompanyService.getCompany(this.profile.companyId)
                    ]);

                    this.company = companyData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Company updated',
                        life: 3000
                    });

                } catch (error) {
                    console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update company. Please try again.',
                        life: 3000
                    });
                }
            }
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
